import * as React from 'react';
import { cn } from '@/lib/utils';

const ProfileResume = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'profile-resume',
      // Estilo base
      'flex max-w-full flex-grow flex-wrap items-center gap-2',
      className
    )}
    {...props}
  />
));
ProfileResume.displayName = 'ProfileResume';

const ProfileResumeBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'profile-resume-body',
      // Estilo base
      'flex w-[100px] flex-grow flex-col items-start gap-1 leading-none',
      className
    )}
    {...props}
  />
));
ProfileResumeBody.displayName = 'ProfileResumeBody';

const ProfileResumeName = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      'profile-resume-name',
      // Estilo base
      'mb-0 w-full max-w-full truncate text-sm font-bold capitalize leading-none text-primary-dark',
      className
    )}
    {...props}
  />
));
ProfileResumeName.displayName = 'ProfileResumeName';

const ProfileResumeEmail = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'profile-resume-email',
      // Estilo base
      'mb-0 max-w-full truncate text-xs font-light leading-none text-neutral',
      className
    )}
    {...props}
  />
));
ProfileResumeEmail.displayName = 'ProfileResumeEmail';

export { ProfileResume, ProfileResumeBody, ProfileResumeName, ProfileResumeEmail };
